import { AppConfig } from '../config/app-config';
import { FVSLocation, TabWithRoute } from '../../core/models/fvs-address-verification.model';
import FVSConstants from './nav-item-v2.constants';

export function checkErrorWithDescription(error?: Record<string, any>) {
    if (error?.error?.error_description) {
        return error?.error?.error_description;
    }

    if (error?.error?.description) {
        return error?.error?.description;
    }
}

export function checkErrorWithResponseMessage(error?: Record<string, any>) {
    if (error?.error?.responseMessage) {
        return error?.error?.responseMessage;
    }
}

export function defaultError() {
    return 'An error occurred while processing this request';
}

export function setHiddenTabs(tabs: TabWithRoute) {
    const tabsCopy = { ...tabs };
    const fvsTabIds = AppConfig.FVS_ADDRESS_VERIFICATION_TABS_TO_HIDE;
    const fvsTabsArray = fvsTabIds.split(',');

    fvsTabsArray.forEach((tab) => {
        const currentTab = tabsCopy[tab];
        if (currentTab) {
            currentTab.show = false;
        }
    });

    return tabsCopy;
}

export function getActiveTabs(tabsArray?: TabWithRoute[string][]) {
    return tabsArray?.filter((tab) => tab.show);
}

export function getFirstTab() {
    const tabs = setHiddenTabs(FVSConstants.tabListWithRoute);
    const tabsArray = Object.values(tabs);
    const activeTabs = getActiveTabs(tabsArray);
    const activeTabRoutesArray = activeTabs?.map((activeTab) => activeTab.route);

    return activeTabRoutesArray?.[0];
}

export function removeUndefinedFromObjects(obj: Partial<Record<string, string>>) {
    const result = {};
    for (const key of Object.keys(obj)) {
        if (obj[key] !== undefined && obj[key] !== null) {
            result[key] = obj[key];
        }
    }
    return result;
}

export function convertLGAaToTableMap(lgas?: FVSLocation[]) {
    return lgas?.reduce(
        (previousNameMap, lga) => ({
            ...previousNameMap,
            [lga.code]: lga.name,
        }),
        {},
    );
}

export function createFilterListFromFilerObject<Key extends string = string, Filter extends Partial<Record<Key, string>> = Record<Key, string>>(
    filterObject: Filter,
    labelKeys: Record<Key, string>,
) {
    return Object.entries({ ...filterObject })
        .filter((filterInstance) => filterInstance[1])
        .map(([key, value]: [Key, string]) => {
            return { key, label: labelKeys[key], value };
        });
}
